import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';

import OkCancelModal from '@/shared/components/OkCancelModal';

import EnumSelect from '@/shared/components/input/EnumSelect';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from './comliancyMessages';

export default class MarkCompliancyInapplicableModal extends Component {
  state = {
    complianceType: undefined,
    inapplicable: true,
  };

  static propTypes = {
    show: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    onSave: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  onSave = () => {
    const { complianceType, inapplicable } = this.state;
    const { onSave } = this.props;
    return onSave({ complianceType, inapplicable });
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  selectedValueChanged = value => {
    this.setState({ complianceType: value });
  };

  render() {
    const { complianceType, inapplicable } = this.state;
    const { show, intl } = this.props;

    if (!show) return null;

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.Compliance)}
        show={show}
        onClose={this.closeModal}
        disabled={complianceType === undefined}
        onSave={() => this.onSave()}
      >
        <div className="form-horizontal">
          <div>
            <div className="form-group">
              <label className="control-label col-md-3">
                <FormattedMessage {...messages.ComplianceType} />
              </label>
              <div className="col-md-9">
                <EnumSelect
                  enumType="compliancetype"
                  onChange={this.selectedValueChanged}
                  orderByLabel
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-md-9 col-md-offset-3 margin5T">
                <Checkbox
                  value={inapplicable}
                  text={intl.formatMessage(messages.NotApplicable)}
                  onClick={value =>
                    this.setState({
                      inapplicable: value,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </OkCancelModal>
    );
  }
}
